<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gXvgMG/media/FC-9781035824915.jpg?1711282185852" alt="This image is the cover for the book Set the Night Alight"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Set the Night Alight
      </h1>
      <p class="bookDescription body article font2">
        <p>In a city shrouded in fear, the eerie disappearance of four women soon escalates to a grim reality when they are found lifeless. The lead detective, though relentless, is pulled off the case due to a lack of leads. He leaves with a chilling warning – the killer will strike again. And strike again, he did, not once but twice. <br/>Fast forward eighteen years, the unsolved case is a haunting blemish on the police department, forcing them to summon the once ostracized detective, Nathan Andrews, back to the chilling scene of the unsolved crimes. With no other recourse, the desperate police force pairs the seasoned Nathan with young officer Julius in a bid to catch the elusive killer. <br/>As Julius is taken under Nathan’s tutelage, he quickly descends into a world far darker than he could have imagined: a world where fear reigns, and even crime lords shudder. Nathan, a man whose secrets are as fearsome as his reputation, walks the sinister path fearlessly, unmasking a reality that’s terrifyingly close to the heart of darkness. <br/>Now, as they venture deeper into the case, Julius realizes that the true terror may not just be the serial killer who set the night alight with dread but the enigmatic Nathan, whose cryptic past holds keys to a realm even the bravest dare not enter.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ethan Alexander
      </h2>
      
      <p class="authorDescription body article">Ethan Alexander was a marine engineer, spending 15 years tearing apart and rebuilding the guts of the engine room. He now spends his time at home, annoying his wife with crazy and funny jokes and noises. He is an avid reader, with 1,000 books taking up space in every room in the house, which annoys his wife to no end. He wrote this book as a way to de-stress and focus the mind after suffering mental health issues in the past. He likes being home with his family, as he missed this before.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e6285f48